export default __webpack_public_path__ + "static/media/management.142589ee.svg";